import { path } from 'ramda'
import { createSelector } from 'reselect'

const getCategories = state => state.expediaEasyms.categories
const getRates = state => state.expediaEasyms.rates

export const selectEasymsCategories = createSelector(
    getCategories,
    categories => path(['entities', 'categories'], categories) || {}
)

export const selectEasymsRates = createSelector(
    getRates,
    rates => path(['entities', 'rates'], rates) || {}
)

export const selectEasymsCategoriesKV = createSelector(getCategories, categories => {
    const categoriesData = path(['entities', 'categories'], categories)

    if (categoriesData)
        return categories.result.map(categoryId => ({
            value: categoryId,
            label: `${categoriesData[categoryId].name} (id: ${categoryId})`
        }))
    return []
})

export const selectEasymsRatesKV = createSelector(getRates, rates => {
    const ratesData = path(['entities', 'rates'], rates)

    if (ratesData)
        return rates.result.map(rateId => ({
            value: rateId,
            label: `${ratesData[rateId].name} (id: ${rateId})`
        }))
    return []
})



// WEBPACK FOOTER //
// ./src/selectors/expediaSelectors/expediaEasymsSelector.js